import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Snackbar, SnackbarMessage } from 'app/components/core/Snackbar';

export function InitiatePrepareDownloadSucceededNotification({ id, onDismiss, viewName }) {
    const { t } = useTranslation();

    return (
        <Snackbar id={id} onDismiss={onDismiss} autoHideEnabled>
            <SnackbarMessage>
                {t('notifications:InitiateDownload', {
                    viewName
                })}
            </SnackbarMessage>
        </Snackbar>
    );
}

InitiatePrepareDownloadSucceededNotification.propTypes = {
    id: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
    viewName: PropTypes.string.isRequired
};
